<template>
    <div id="app">
        <router-view />
        <floatBtn v-if="$route.path!='/tips'" />
    </div>
</template>

<script>
import { getJsonResource } from "@/api/home";
import floatBtn from "@/components/floatBtn";
export default {
    name: "App",
    components: {
        floatBtn,
    },
    mounted() {
        this.$nextTick(() => {
            this.safariHacks();
        });
        this.lang();
        window.addEventListener("orientationchange", () => {
            location.reload();
        });
        this.isWeixin();
        let search = this.getlocation();
        this.$store.commit('order/SET_channelcode', search.channelcode || '');
    },
    methods: {
        safariHacks() {
            let windowsVH = window.innerHeight / 100;
            document
                .querySelector("#app")
                .style.setProperty("--vh", windowsVH + "px");
            window.addEventListener("resize", function () {
                document
                    .querySelector("#app")
                    .style.setProperty("--vh", windowsVH + "px");
            });
        },
        lang() {
            let lang = this.$store.state.app.language;
            getJsonResource({ code: lang }).then((res) => {
                localStorage.setItem(
                    "smarttranslang",
                    JSON.stringify(res.data.internal)
                );
                this.$i18n.locale = lang;
                this.$store.dispatch("setLanguage", lang);
                this.$i18n.mergeLocaleMessage(lang, res.data.internal);
            });
        },
        isWeixin() {
            // 匹配微信内部
            let ua = navigator.userAgent.toLocaleLowerCase();
            if (ua.includes('micromessenger')) {
                if (this.$route.path != '/tips') {
                    this.$router.replace({ path: "/tips" });
                }
            } else {
                if (this.$route.path == '/tips') {
                    this.$router.replace({ path: "/home" });
                }
            }
        },
        getlocation() {
            // 获取查询字符串
            var queryString = window.location.search;
            // 去除开头的问号
            queryString = queryString.substr(1);
            // 分离参数（键值对）
            var parameters = queryString.split("&");
            var params = {};
            parameters.forEach(function (param) {
                // 分离键和值
                var keyValuePair = param.split("=");
                var key = decodeURIComponent(keyValuePair[0]);
                var value = decodeURIComponent(keyValuePair[1]);
                // 存储键值对
                params[key] = value;
            });
            return params;
        }
    },
};
</script>
<style lang="scss" scoped>
#app {
    position: absolute;
    width: 100%;
    // min-height: 100vh; /*給 Safari 以外的瀏覽器讀取*/
    min-height: calc(var(--vh, 1vh) * 100);
}
.home-container {
    // min-height: 100vh; /*給 Safari 以外的瀏覽器讀取*/
    min-height: calc(var(--vh, 1vh) * 100);
}
</style>



// WEBPACK FOOTER //
// src/App.vue